<template>
<div>
    <vue-upload-component
      ref="upload"
      v-model="files"
      @input-filter="inputFilter"
      @input-file="inputFile"
      :multiple="false"
      :drop="true"
      :class="themeClass + ' vue-upload'"
    >
      <div class="upload-dropzone">
        <span class="upload-text">
          {{ isDropActive ? 'Drop Here' : 'Upload' }}
        </span>
      </div>
    </vue-upload-component>
</div>

</template>

<script>
import VueUploadComponent from 'vue-upload-component'
export default {
  name: 'FileSelect',
  components: {
    VueUploadComponent
  },
  props: {
    theme: {
      type: String,
      default: 'light' // 'light' or 'dark'
    }
  },
  mounted () {
    window.addEventListener('dragenter', this.handleDragEnter)
    window.addEventListener('dragend', this.handleDragEnd)
    window.addEventListener('dragleave', this.handleDragLeave)
    window.addEventListener('drop', this.handleDrop)
  },
  data () {
    return {
      dragActive: false,
      files: []
    }
  },
  computed: {
    themeClass () {
      return this.theme === 'light' ? 'light' : 'dark'
    },
    isDropActive () {
      return this.dragActive || (this.$refs.upload && this.$refs.upload.dropActive)
    }
  },
  methods: {
    handleDragEnter () {
      this.dragActive = true
    },
    handleDragEnd () {
      this.dragActive = false
    },
    handleDrop () {
      this.dragActive = false
    },
    inputFile (newFile, oldFile) {
      this.$emit('input-file', newFile)
    },
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png)$/i.test(newFile.name)) {
          return prevent()
        }
      }
      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    }
  }
}
</script>

<style lang="scss">
  .vue-upload label {
    cursor: pointer;
  }
</style>

<style lang="scss" scoped>
  .vue-upload {
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .upload-dropzone {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px dashed #000;
  }
  .upload-text {
    color: rgba(0,0,0,0.8);
    font-weight: bold;
  }
  .dark {
    .upload-dropzone {
      border: 2px dashed rgba(255,255,255,0.8);
    }
    .upload-text {
      color: rgba(255,255,255,0.9);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FileSelect.vue